module.exports = __webpack_public_path__ + "img/QLIK ppt for website 1.f99827ad.png";